import {sigTooltipHandler} from './file_signatures';
import {findApplicant} from './rating_applicants';

function setContentMarginBottom() {
    const element = document.getElementById('pro-footer');
    if (element) {
        const footerHeight = document.getElementById('pro-footer').offsetHeight;
        $_pro('#pro-section').css('margin-bottom', `${footerHeight}px`);
    }
}

function setHashUrlFromEl(domObj) {
    const hashForElement = domObj.attr('href');
    if (hashForElement !== 'undefined' && hashForElement.indexOf('#') === 0) {
        if (window.history && history.pushState) {
            // IE10, Firefox, Chrome, etc.
            window.history.replaceState(null, null, hashForElement);
        } else {
            // old
            const pos = $_pro(window).scrollTop(); // get scroll position
            window.location.hash = hashForElement;
            $_pro(window).scrollTop(pos); // set scroll position back
        }
    }
}

function openPathToElem(pathToElem) {
    if (pathToElem.length > 0) {
        $_pro.each(pathToElem, (index, piecePath) => {
            const tab = $_pro('.nav-tabs , #nav-menu-list').find(`${' a[href="' + '#'}${piecePath}"]`);
            if (tab.length > 0) {
                tab.tab('show');
            } else {
                setTimeout(() => {
                    if ($_pro(`#${piecePath}`).length) {
                        $_pro('html,body').animate({scrollTop: $_pro(`#${piecePath}`).offset().top}, 'high');
                    }
                }, 500);
            }
        });
    }
}

function createOpenPathToElem(domObj) {
    const hashPieces = [];
    const hashForElement = domObj.attr('id');
    if (hashForElement !== 'undefined') {
        hashPieces.unshift(hashForElement);
        const parentsPanes = $_pro(domObj.parents('.tab-content .tab-pane'));
        $_pro.each(parentsPanes, (index, tabPane) => {
            if ($_pro(tabPane).attr('id') !== 'undefined') {
                hashPieces.unshift($_pro(tabPane).attr('id'));
            }
        });
    }
    return hashPieces;
}

$_pro(window).on('resize', () => {
    setContentMarginBottom();
});

$_pro(document).ready(() => {
    $_pro('#pro-wrapper').show();
    setContentMarginBottom();
    const {hash} = location;
    if (hash.replace('#', '')) {
        if (hash.indexOf('#abitur_') >= 0) {
            const newHash = hash.replace('#abitur_', '');
            $_pro('[id=abitur-hrefs]').find(`[data-href=${newHash}]`).click();
        } else {
            const el = $_pro(hash);
            if (el.length == 1) {
                openPathToElem(createOpenPathToElem(el));
            }
        }
    }

    $_pro('.open-tooltip-anchor').tooltip({
        placement: 'left',
        scrollableElement: 'html,body',
        template: '<span class="anchor-tooltip-wrap text-primary" role="tooltip" >'
            + '<span class="tooltip-inner transparent"></span></span>',
        trigger: 'hover focus',
        title() {
            return `<a  class="anchor-get"  href="#${$_pro(this).attr('id')}">`
                + '<span class="glyphicon glyphicon-link" aria-hidden="true"></span>'
                + '</a>';
        },
        html: true,
        delay: {show: 50, hide: 1600},
    });

    $_pro(document)
        .on('click', '.anchor-get, #nav-menu-list a, .nav-tabs a', function (e) {
            setHashUrlFromEl($_pro(this));
        })
        .on('click', '#abitur_stoimost_link', (e) => {
            openPathToElem(createOpenPathToElem($_pro('#anchor_paidEduStoimDocLink')));
        })
        .on('click', '.resizing-box + .read-more .button', function () {
            const $elem = $_pro(this).parent().prev('.resizing-box');
            $_pro('.anchor-tooltip-wrap').remove();
            if ($elem.hasClass('short')) {
                $elem.removeClass('short');
                $_pro(this).text('Свернуть');
            } else {
                $elem.addClass('short');
                $_pro(this).text('Развернуть');
            }
        })
        .on('click', '.tr-accordion', function () {
            const $currentTr = $_pro(this);
            const span = $currentTr.find('span.glyphicon');
            const label = $currentTr.find('span.show-or-hide-text');
            const $table = $currentTr.closest('table');
            const id = $currentTr.data('id');
            if (!span.hasClass('glyphicon-minus')) {
                span.addClass('glyphicon-minus');
                label.html('&nbsp;Скрыть');
                $table.find(`tr[data-tr-id=${id}]`).show();
            } else {
                span.removeClass('glyphicon-minus');
                label.html('&nbsp;Показать');
                $table.find(`tr[data-tr-id=${id}]`).hide();
            }
        });

    $_pro('body').tooltip({
        selector: '.tooltip-sig',
        html: true,
        title: sigTooltipHandler,
        placement: 'auto',
    });

    if (!$_pro('[name=data_remote_uri]').length) {
        findApplicant();
    }

    $_pro('[data-toggle="popover"]').popover();
});
